// @ts-nocheck
import Vue from "vue";
import { mapGetters } from "vuex";
import Stackorder from "@/classes/Stack/StackOrder";
import PostStackorder from "@/classes/Stack/PutStackorder";
import dateFormatter from "@/utility/dateFormatter";
import StackOrderModalHeader from "./StackOrderModalHeader.vue";
import SuffixFormattedInput from "../common/SuffixNumberFormattedInput.vue";
import DatePicker from "../common/DatePicker.vue";
import StackTypeSelector from "./StackTypeSelector.vue";
import TariffAutocomplete from "./TariffAutocomplete.vue";
import TariffList from "./TariffList.vue";
import { createStackOrder } from "@/services/stackOrderService";
import { AxiosError } from "axios";
export default Vue.extend({
    props: {
        stackOrder: {},
    },
    components: {
        StackOrderModalHeader,
        DatePicker,
        SuffixFormattedInput,
        StackTypeSelector,
        TariffAutocomplete,
        TariffList,
    },
    data() {
        return {
            editableStackOrder: {},
            saving: false,
            defaultStackorder: {
                name: "",
                from: new Date().toISOString(),
                to: new Date().toISOString(),
                tariffIds: [],
                userId: this.currentUser,
                type: "Weekly",
                hourLimit: undefined,
            },
            validation: {
                required: (value) => !!value || "Cannot be empty",
            },
        };
    },
    created() {
        if (this.stackOrder) {
            this.editableStackOrder = new Stackorder(this.stackOrder);
        }
        else {
            this.editableStackOrder = new Stackorder(this.defaultStackorder);
        }
    },
    computed: {
        ...mapGetters({
            currentUser: "getLoggedInUser",
            globalTariffCollection: "getGlobalTariffs",
        }),
        connectedTariffIds() {
            return this.editableStackOrder.tariffIds || [];
        },
        tariffs() {
            return this.globalTariffCollection.tariffs || [];
        },
        connectedTariffs() {
            const connectedTariffs = this.tariffs.filter((tariff) => this.connectedTariffIds.includes(tariff.id));
            return connectedTariffs;
        },
        selectableTariffs() {
            const selectableTariffs = this.tariffs
                .filter((tariff) => tariff.type == "Stack")
                .filter((tariff) => !this.connectedTariffIds.includes(tariff.id));
            const sortedTariffs = selectableTariffs.sort((a, b) => a.name.localeCompare(b.name));
            return sortedTariffs;
        },
    },
    methods: {
        isValid() {
            return this.$refs.form.validate();
        },
        async onCreate() {
            if (!this.isValid()) {
                return;
            }
            const stackorder = PostStackorder.constructFrom(this.editableStackOrder);
            stackorder.userId = this.currentUser.userId;
            try {
                this.saving = true;
                await createStackOrder(stackorder);
                this.$emit("update");
                this.$emit("close");
            }
            catch (error) {
                if (error instanceof AxiosError) {
                    console.log(error);
                    this.$store.dispatch("ToastMessage", {
                        type: "error",
                        message: "Unable to create stack order: " + error.response &&
                            error.response.data,
                    });
                }
            }
            finally {
                this.saving = false;
            }
        },
        onRemoveTariffConnection(tariffId) {
            const index = this.connectedTariffIds.findIndex((tariff) => tariff == tariffId);
            this.editableStackOrder.tariffIds.splice(index, 1);
        },
        async onTariffSelected(tariffId) {
            this.editableStackOrder.tariffIds.push(tariffId);
        },
        onFromDateChange(date) {
            this.editableStackOrder.from =
                dateFormatter.fromDateString(date).shift.toStartOfdayUtc;
        },
        onToDateChange(date) {
            this.editableStackOrder.to =
                dateFormatter.fromDateString(date).shift.toEndOfUtcDay;
        },
        onAllicationidelityChange(fidelity) {
            this.editableStackOrder.type = fidelity;
        },
    },
});
